<template lang="html">
    <!--
    Emit-ul va inchide si daca apesi pe modal, trebuie implementata o functie calumea
        - Paul
    <div class="modal-overlay" @click="$emit('close')">
    -->

    <!--
        Posibil breaking-change: când este apăsat pe overlay, se închide modalul (se dă stopPropagation la event dacă userul apasă pe modalul în sine)
            - Paul
    -->
    <div class="modal-overlay" @click="$emit('close', $event)">
        <div
            class="modal"
            :class="{
                'modal--mobile': (this.$store.state.layout.isMobile || this.$route.name == 'MeetingRoom' || this.$route.name == 'AnytimeMeetingRoom')
            }"
            :style="{
                'max-height': innerHeight+'px'
            }"
            @click="$event.stopPropagation()"
        >
            <div class="modal__head">
                <div class="modal__head-group">
                    <div class="modal__title">{{title}}</div>
                    <div class="modal__close" @click="$emit('close', $event)">
                        <i class="fa fa-arrow-left"></i>
                    </div>
                </div>
                <div class="modal__subtitle">{{subtitle}}</div>
            </div>
            <div class="modal__body modal__body--v-scrollable">
                <slot name="body"></slot>
            </div>
            <div class="modal__footer">
                <div class="modal__action" :class="{'modal__action--force-wrap' : actionForceWrap, 'modal__action--col': (buttonsStyle == 'col' && buttons.length > 1)}">
                    <button v-for="(button, index) in buttons"
                        :key="index"
                        @click="sendEvent(button)"
                        class="modal__button"
                        :class="{
                            'modal__button--gradient' : button.style === 'gradient',
                            'modal__button--round' : button.round,
                            'modal__button--disabled' : button.disabled,
                            'modal__button--close' : button.style === 'close',
                            'modal__button--danger' : button.style === 'danger',
                            'modal__button--margin-top' : index > 1
                        }">
                        <i v-if="button.icon" :class="button.icon"></i>
                        {{button.text}}
                    </button>
                </div>
                <div class="modal__credits" v-if="credits">
                    <i :class="credits.icon" class="modal__credits--icon"> </i>
                    <div class="modal__credits--text">
                        {{credits.text}}
                    </div>
                    <a :href="credits.link" target="_blank" class="modal__credits--link">{{credits.linkTitle}}</a>
                </div>
            </div>
            <slot name="outside"></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        active: {
          type: Boolean,
          default: false,
        },
        title: {
          type: String,
          default: "",
        },
        subtitle: {
          type: String,
          default: "",
        },
        buttons: {
          type: Array,
          default: function () {
            return [];
          },
        },
        buttonsStyle: {
            type: String,
            default: 'col' //col or row
        },
        actionForceWrap: {
            type: Boolean,
            default: false,
        },
        credits: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            innerHeight: 0
        };
    },
    mounted() {
        document.body.style.overflow = 'hidden';
        this.innerHeight = window.innerHeight;

        let modalElement = document.getElementsByClassName('modal')[0];
        let VueThis = this;
        function resetModalHeight(){
            if(window.innerWidth <= 576) //SM
                VueThis.innerHeight = window.innerHeight;
        }

        resetModalHeight(); 
        window.onscroll = function() {resetModalHeight();}
        window.onresize = function() {resetModalHeight();}
        window.onorientationchange = function() {resetModalHeight();}

        //Add bottom shadow for vertical scrollable body descendents [PROTOTYPE - We might remove it..] | removed later - not working properly

        // let modalBody = document.getElementsByClassName('modal__body')[0];
        // let modalBodyDescendents = modalBody.getElementsByTagName('*');
        
        // var i, currentDescendent;

        // for (i = 0; i < modalBodyDescendents.length; ++i) {
        //     currentDescendent = modalBodyDescendents[i];

        //     if(currentDescendent.scrollHeight > currentDescendent.offsetHeight + 5){ //error = 5px
        //         if(!currentDescendent.classList.contains('vertical-scrollable')) currentDescendent.classList.add('vertical-scrollable');

        //         console.log(currentDescendent.scrollHeight + ' | ' + currentDescendent.offsetHeight);
        //     }
        // }

    },
    destroyed() {
        document.body.style.overflow = null;
    },
    methods: {
        sendEvent(button) {
            if (button.event && button.disabled !== true) {
                this.$emit(button.event);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
    .modal-overlay {
        position: fixed;
        width: 100%;
        height: 100vh;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.4);
        display: flex;
        z-index: 21;
    }
    .modal {
        display: flex;
        flex-direction: column;
        position: absolute;
        top: 50%;
        left: calc(50% + 140px);
        transform: translate(-50%,-50%);
        padding: 20px;
        width: 100%;
        height: 100%;
        z-index: 21;
        background-color: white;
        @include media-breakpoint-up(sm) {
            max-width: 500px;
            height: initial;
        }

        @include media-breakpoint-up(md) {
            max-width: 600px;
            height: initial;
        }

        @include media-breakpoint-down(sm) {
            position: fixed;
        }
        &--mobile{
            left: 50%;
        }
        &__head {
            display: flex;
            flex-direction: column;
        }
        &__body {
            position: relative; //added rj - 21.04.2021
            overflow-y: auto;
            min-height: 20vh;
            max-height: 75vh;
            display: flex;
            flex-direction: column;
            @include media-breakpoint-up(sm){
                max-height: 60vh;
            }
        }
        &__footer {
            margin-top: auto;
            width: 100%;
            // display: flex;
            // flex-direction: row;
            // flex-wrap: wrap;
            // column-gap: 52px;
            // row-gap: 10px;
            // justify-content: space-between;
            // @include media-breakpoint-up(sm) {
            //     flex-wrap: nowrap;
            // }
        }
        &__close {
            font-size: 25px;
            cursor: pointer;
            z-index: 1000; //in order to be able to close iframe
        }
        &__head-group{
            display: flex;
            justify-content: space-between;
        }
        &__title {
            color: $color-main-text;
            font-family:'DIN Pro', sans-serif;
            font-weight: 700;
            font-size: 24px;
        }
        &__subtitle{
            font-family: 'Roboto', sans-serif;
            margin-top: 12px;
            font-size: 14px;
            color: #373435;
            opacity: 0.7;
        }
        &__action {
            margin-top: auto;
            max-width: 100%;
            width: 100%;
            display: grid;
            grid-gap: 10px;
            grid-template-columns: 1fr;
            // display: flex;
            // flex-direction: row;
            // flex-wrap: wrap;
            // justify-content: space-between;
            // @include media-breakpoint-up(sm) {
            //     flex-wrap: nowrap;
            // }
            &--force-wrap{
                flex-wrap: wrap;
            }
            &--col {
                grid-gap: 52px;
                grid-template-columns: repeat(2, 1fr);
            }
        }
        &__button {
            display: flex;
            align-items: center;
            justify-content: center;
            // min-width: calc((100% - 52px)/2);
            // width: calc((100% - 52px)/2);
            width: 100%;
            height: 45px;
            font-family: "DIN Pro";
            font-weight: 500;
            font-size: 16px;
            background: $color-primary;
            border: none;
            color: #FFFFFF;
            outline: none;
            cursor: pointer;
            white-space: nowrap;
            i{
                font-size: 18px;
                margin-right: 5px;
            }
            &:hover {
                opacity: 0.8;
            }
            &:active {
                opacity: 1;
            }
            &:only-child {
                margin-right: 0;
            }
            &--gradient{
                background: transparent linear-gradient(90deg, $color-primary 0%, $color-secondary 100%) 0% 0% no-repeat padding-box;
            }
            &--close{
                background: rgba($color-main-text, 0.25);
            }
            &--danger{
                background: $color-danger;
            }
            &--round {
                cursor: pointer;
                border-radius: 18px;
            }
            &--disabled {
                opacity: 0.7;
                cursor: not-allowed;
            }
            &--margin-top {
                margin-top: 10px;
            }
        }
        &__credits {
            width: 100%;
            display: flex;
            flex-direction: row;
            justify-content: center;
            margin-top: 10px;
            &--icon {
                color: rgba($color-gray, 0.7);
                margin: 0 2px;
            }
            &--text {
                font-family: 'Roboto', sans-serif;;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 20px;
                color: rgba($color-gray, 0.7);
                margin: 0 2px;
            }
            &--link {
                font-family: 'Roboto', sans-serif;;
                font-style: normal;
                font-weight: normal;
                font-size: 14px;
                line-height: 20px;
                color: #928CFF;
                text-decoration: none;
                margin: 0 2px;
            }
        }
    }
    .content {
        font-family: DIN Pro;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
        margin-top: 25px;

        &--center {
            text-align: center;
        }
        span {
            color: $color-primary;
        }
        &__spacer{
            height: 35px;
        }
        &__line{
            height: 1px;
            background: rgba(#373435, 25%);
            width: 100%;
            margin-top: 20px;
        }
        &__heading {
            font-weight: 500;
            font-size: 18px;
            line-height: 20px;
            width: 100%;
            margin-top: 30px;
            &--center {
                text-align: center;
            }
            span {
                color: $color-primary;
            }
        }
        &__info {
            font-family: 'DIN Pro', sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 20px;
            color: rgba($color-gray, 0.7);
            margin-top: 20px;
            &--center {
                text-align: center;
            }
        }
    }
</style>
